import { FilterItem } from '@mm/components';
import { SubscriptionFeatureFlag } from '@mm/state/controllers/FeatureFlags';
import { nextBillingTypeForFeatureSelector } from '@mm/state/selectors/featureFlagsSelectors';
import { StoreState } from '@mm/state/store-interfaces';
import classNames from 'classnames';
import React from 'react';
import { useSelector } from 'react-redux';
import { PlanBadge } from '../../../../../../common/components/ProBadge';
import { trackWebAppGAEvent } from '../../../../../../common/helpers/plugins/website-google-analytics';
import '../AutomationRules.pcss';
import { automationTypeByKind, UIFilterAutomationRuleKindType } from '../types';

type Props = {
  className?: string;
  activeKind?: UIFilterAutomationRuleKindType;
  onChange?: (kind?: UIFilterAutomationRuleKindType) => void;
};

const kinds: UIFilterAutomationRuleKindType[] = [
  'system_messages',
  'business_hours',
  'follow_ups',
  'lead_assignments',
];

const requiredFeatures: Record<
  UIFilterAutomationRuleKindType,
  SubscriptionFeatureFlag | undefined
> = {
  follow_ups: 'automationRulesFollowUps',
  lead_assignments: 'leadsAssignment',
  business_hours: 'automationRulesBusinessHours',
  system_messages: undefined,
};

const AutomationRulesFilterByKindItem = ({
  kind,
  onChange = () => {},
  activeKind,
}: Props & {
  kind: UIFilterAutomationRuleKindType;
}) => {
  const { name } = automationTypeByKind[kind] || {};
  const requiredFeature = requiredFeatures[kind];

  const billingType = useSelector((state: StoreState) =>
    nextBillingTypeForFeatureSelector(state, requiredFeature),
  );

  return (
    <FilterItem<UIFilterAutomationRuleKindType | undefined>
      key={name}
      item={kind}
      title={name}
      onClick={() => {
        trackWebAppGAEvent('click', {
          category: 'automation_rule_filter_by_type',
          label: `automation_rule_filter_${kind}`,
        });
        onChange(kind);
      }}
      isActive={kind === activeKind}
    >
      {billingType && (
        <PlanBadge
          className="automation-rules__plan-badge"
          billingType={billingType}
          size={10}
        />
      )}
    </FilterItem>
  );
};

export const AutomationRulesFilterByKind = (props: Props) => {
  const { className } = props;
  return (
    <div className={classNames(className)}>
      {kinds.map(kind => (
        <AutomationRulesFilterByKindItem key={kind} {...props} kind={kind} />
      ))}
    </div>
  );
};
